module.exports = __webpack_public_path__ + "img/logo.fcb50e2d.png";